'use client'
import Page from '~/containers/Cart/Cart';

export default Page;
